<div id="accordion" class="application-form" style="padding-top: 50px;">
    <app-payment-amount number="1" [active]="vm.active === vm.slides.makePayment"
        [complete]="vm.slides.makePaymentComplete" [enterAmountHeading]="enterAmountHeading"
        [enterAmountSubHeading]="enterAmountSubHeading" [enterAmountBody]="enterAmountBody"
        [continuePaymentButtonText]="continuePaymentButtonText" (TitleClickEvent)="back()"
        (CompleteEvent)="paymentAmountComplete()">
    </app-payment-amount>
    <app-payment-card-details number="2" [active]="vm.active === vm.slides.cardDetails"
        [complete]="vm.slides.cardDetailsComplete" [cardDetailsHeading]="cardDetailsHeading"
        [cardDetailsSubHeading]="cardDetailsSubHeading" [cardDetailsBody]="cardDetailsBody"
        [paySecurelyButtonText]="paySecurelyButtonText" [failedPaymentMessage]="failedPaymentMessage"
        [errorPaymentMessage]="errorPaymentMessage" [processingPaymentTitle]="processingPaymentTitle"
        [processingPaymentBody]="processingPaymentBody" [paymentCardPageUrl]="paymentCardPageUrl" (BackEvent)="back()">
    </app-payment-card-details>
</div>